
import { FriendlyNumberConfig } from "@/models/dossier-configs/friendly-number-config";
import { BookYearService } from "@/services/book-year-service";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			editPrefix: false
		};
	},
	props: {
		value: {
			type: Object as ()=> FriendlyNumberConfig,
			required: true
		},
		bookyear: {
			type: Number,
			default: () => {
				return BookYearService.selectedBookYear;
			}
		},
	},
	computed: {
		computedPrefix(): string {
			let result = this.value.Prefix;
			let bookyearShort = `${this.bookyear}`.substring(2);
			result = result.replace("{bookyearShort}", bookyearShort);
			result = result.replace("{bookyear}", BookYearService.selectedBookYear + "");
			return result;
		},
	},
	methods: {
		async editPrefixClicked() {
			this.editPrefix = true;
			await this.$nextTick();
			(this.$refs.prefixInput as any).focus();
		},
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
